import "./VendorLabel.less";

interface IVendorLabelProps {
    children: React.ReactNode;
}
const VendorLabel: React.FC<IVendorLabelProps> = ({ children }) => {
    return <span className="VendorLabel LabelText">{children}</span>;
};

export default VendorLabel;
